import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { RequestService, LayoutUtilsService } from '../../../shared/services';
import { FormControl, FormGroupDirective, NgForm, FormGroup } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

export class My2ErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
,
  standalone: false})
export class CustomSelectComponent implements OnInit {

  public apiCallSubscription: any = undefined;
  public errorMessage: string = '';
  public loading: boolean = false;
  selectData: Array<any> = [];

  public dataText: string = '';
  stateCtrl = new FormControl();
  /* pagination Info */
  pageSize = 100;
  pageNumber = 1;
  orderDir = 'asc';
  orderBy = 'name';
  searchText = '';
  public panelOpened: boolean = false;

  myControl = new FormControl();
  filteredData: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  public hideBecauseOne: boolean = false;
  private _parentFormSubmitted = false;
  @Input() clearable: boolean = false;
  @Input() required: boolean = false;
  @Input() hideIfOne: boolean = false;
  public esMatcher = new My2ErrorStateMatcher();
  @Input() displayName: string[] = ['name', 'text'];
  @Input() filters: any;
  @Input() itemName: string = '';
  @Input() placeholder: string = '';
  @Input() dataType: string;
  @Input() subDataType: string;
  @Input() apiTarget: string = 'list';
  @Input() value: any;
  @Input() conditionalDisable: boolean = false;
  @Input()
  set parentFormSubmitted(parentFormSubmitted: boolean) {
    this._parentFormSubmitted = parentFormSubmitted;
    if (parentFormSubmitted) {
      if (this.form)
        this.form.onSubmit(undefined);
    }
  }
  get parentFormSubmitted(): boolean {
    return this._parentFormSubmitted;
  }
  @Output() onSelectReturn = new EventEmitter<any>();
  @Output() onRoleSelectReturn = new EventEmitter<any>();
  @ViewChild('dataForm') form: NgForm;
  constructor(private translate: TranslateService,
    private requestService: RequestService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef
  ) { }
  ngAfterViewInit() {
    if (this.parentFormSubmitted) {
      if (this.form)
        this.form.onSubmit(undefined);
    }
  }
  ngOnInit() {
    this.loadData();
  }
  public onSubmit() {
    // do nothing
  }
  private getSelectedItem(val) {
    for (let itm of this.selectData) {
      if (val === itm._id) {
        return itm
      }
    }
    return '';
  }
  public setAttribute(val) {
    let valT = undefined;
    if (this.apiTarget === 'search') {
      if (val)
        valT = val._id;
      if (this.dataType === 'resourcetypes') {
        let selectedItem = this.getSelectedItem(valT);
        this.onRoleSelectReturn.emit(selectedItem);
      } else {
        this.onSelectReturn.emit(valT);
      }
    } else if (this.apiTarget === 'searchObject') {
      if (val)
        this.onSelectReturn.emit(val);
    } else if (this.dataType == 'tile' && this.apiTarget === 'summary') {
      if (val) {
        this.value = val;
        this.dataText = this.getDataByID(JSON.parse(JSON.stringify(val)));
        this.stateCtrl.setValue({ _id: val, text: this.dataText });
        this.onSelectReturn.emit(val);
      }
    } else {
      if (val)
        valT = val.value;
      if (this.dataType === 'resourcetypes') {
        let selectedItem = this.getSelectedItem(valT);
        this.onRoleSelectReturn.emit(selectedItem);
      } else {
        this.onSelectReturn.emit(valT);
      }
    }
  }
  displayFn(data?: any): string | undefined {
    return data ? data.text : undefined;
  }
  public loadData() {
    if (this.dataType == 'tile' && this.apiTarget === 'summary') {
      this.loadTileDataSearch();
    } else if (this.dataType == 'qascore' && this.apiTarget === 'summary') {
      this.loadDataSearch();
    } else if (this.apiTarget === 'searchObject') {
      this.loadDataSearch();
    } else if (this.apiTarget === 'search') {
      this.loadDataListOrg();
    } else if (this.apiTarget === 'list/organization') {
      this.loadDataListOrg();
    } else if (this.apiTarget === 'list/application') {
      this.loadDataListApp();
    } else {
      this.loadDataList();
    }
  }
  onBlurMethod(term): any {
    if (this.value && this.value !== '') {
      this.dataText = this.getDataByID(JSON.parse(JSON.stringify(this.value)));
      this.stateCtrl.setValue({ _id: this.value, text: this.dataText });
    } else {
      if (!this.panelOpened) {
        this.termSearchTile('');
      }
    }
  }
  public loadTileDataSearch(searching = false) {
    if (this.loading && this.apiCallSubscription) {
      this.apiCallSubscription.unsubscribe();
      this.loading = false;
    }
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      let include = undefined;
      if (this.value) {
        include = [this.value];
      }

      let filterConfiguration = this.addOrganizationToFilter(this.filters);
      this.apiCallSubscription = this.requestService.getDataListSummary(this.dataType, { page: this.pageNumber, term: this.searchText, perpage: this.pageSize, filter: filterConfiguration, include: include }, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
            this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
          }
          if (data) {
            this.selectData = data.results.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
            // this.setAutoOne(this.selectData[0]._id);
          }
          this.filteredData.next(this.selectData);
          if (!searching) {

            if (this.value) {
              this.dataText = this.getDataByID(JSON.parse(JSON.stringify(this.value)));
              if (this.dataType == 'tile' && this.apiTarget === 'summary') {
                this.stateCtrl.setValue({ _id: this.value, text: this.dataText });
              }
            } else {
              this.dataText = '';
              if (this.dataType == 'tile' && this.apiTarget === 'summary') {
                this.stateCtrl.setValue(null);
              }
            }
          }
          this.loading = false;
          this.cdr.markForCheck();
        });
      });
    }
  }
  getDataByID(id): any {
    for (let lst of this.selectData) {
      if (lst._id === id) {
        return lst.text;
      }
    }
    return '';
  }
  public loadDataList() {

    let isCached = true;
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });

      if (this.dataType == "diagnostic") {
        isCached = false;
      }
      this.requestService.getDataL(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      }, isCached, undefined, undefined, this.subDataType);
    }
  }
  public loadDataListApp() {

    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      this.requestService.getDataL(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      }, false, this.requestService.appId);
    }
  }
  public loadDataListOrg() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      this.requestService.getDataLByOrg(this.dataType, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      });
    }
  }
  addOrganizationToFilter(filters) {
    const orgFilter = { 'organizationId': { $eq: this.requestService.orgId } };

    if (!filters || !filters.$and || !Array.isArray(filters.$and)) {
      return {
        $and: [orgFilter]
      };
    }

    // Check if organizationId is already present
    const hasOrgFilter = filters.$and.some(condition => {
      return condition.hasOwnProperty('organizationId');
    });

    if (!hasOrgFilter) {
      filters.$and.push(orgFilter);
    }

    return filters;
  }

  public loadDataSearch() {
    if (!this.loading) {
      // Defer loading state update
      queueMicrotask(() => {
        this.loading = true;
        this.errorMessage = '';
        this.cdr.markForCheck();
      });
      let filterConfiguration = this.addOrganizationToFilter(this.filters);
      this.requestService.getDataListSummary(this.dataType, { page: this.pageNumber, term: this.searchText, perpage: this.pageSize, filter: filterConfiguration, fieldKeys: ['name'] }, (data, error) => {
        // Defer all updates to avoid ExpressionChangedAfterItHasBeenCheckedError
        queueMicrotask(() => {
          if (error) {
            this.errorMessage = error;
            this.layoutUtilsService.showNotification(this.translate.instant('Error:') + error, this.translate.instant('Dismiss'));
          }
          if (data) {
            this.selectData = data.results;
          } else {
            this.selectData = [];
          }
          if (this.hideIfOne && this.selectData.length === 1) {
            this.hideBecauseOne = true;
          }
          this.filteredData.next(this.selectData);
          this.loading = false;
          this.cdr.markForCheck();
        });
      });
    }
  }
  termSearch(e): any {
    this.searchText = e.term;
    this.loadDataSearch();
  }
  termSearchTile(e): any {
    this.searchText = e;
    this.loadTileDataSearch(true);
  }

  public clearData() {
    this.dataText = '';
    if (this.dataType == 'tile' && this.apiTarget == 'summary') {
      this.stateCtrl.setValue(null);
    } else {
      this.stateCtrl.setValue({ _id: '', text: this.dataText });
    }
    this.onSelectReturn.emit('');
  }
  public closed() {
    this.panelOpened = false;
    this.termSearchTile('');
  }
  public opened() {
    this.panelOpened = true;
  }
}
